import React, { useEffect } from 'react'
import Mission from './component/Mission/Mission'
import Solution from './component/Solution/Solution'
import Footer from "../../components/footer/Footer";

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div>
      <Mission />
      <Solution />
      <Footer />
    </div> 
  )
}

export default AboutPage
